import { Button, Card, Spinner, Typography } from '@material-tailwind/react'
import React, { useState, useEffect } from 'react'
import { useForm } from 'react-hook-form';
import AInput from '../../components/fields/AInput';

import AIcon from '../../components/partials/AIcon';
import UploadPhoto from '../../components/upload/UploadPhoto';
import { useShared } from '../../hooks/useShared';
import { ToastContainer, toast } from 'react-toastify';
import ResetPassword from './ResetPassword';
import ASpinner from '../../components/partials/ASpinner';
import ABreadcrumbs from '../../components/breadcrumbs/ABreadcrumbs';


const breadcrumbs =[{name:'پروفايل', link:'/profile'}];
const newModelInputFields = [
   
    { label: 'اسم', name: 'fname', type: 'text', roles: [1], icon: 'person-outline', className: '', required: 'Please enter your first name', isStyle: false, isDisabled: true },
    { label: 'تخلص', name: 'lname', type: 'text', roles: [1], icon: 'person-outline', className: '', required: false, isStyle: false, isDisabled: true },
    { label: 'اسم پدر', name: 'father_name', type: 'text', roles: [1], icon: 'person-outline', className: '', required: false, isStyle: false, isDisabled: true },
    { label: 'شماره تماس', name: 'phone', type: 'text', roles: [1], icon: 'call-outline', className: '', isStyle: false, isDisabled: true },
    { label: 'ايميل', name: 'email', type: 'email', roles: [1], icon: 'at-outline', className: '', required: 'Please enter your email address', isStyle: false, isDisabled: true },
    { label: 'ادرس', name: 'home_address', type: 'textarea', roles: [1], icon: 'book-outline', className: '', required: false, isStyle: false, isDisabled: true },
   
];


export default function Profile() {
    const { auth: { user }, http, setUser, setPhoto,setModel, consts } = useShared()
    const { register, handleSubmit, formState: { errors }, reset } = useForm({});

    const [errorMessage, setErrorMessage] = useState(null)
    const [loading, setLoading] = useState({ info: false, submit: false })
    const [member, setMember] = useState(null)
    const [editInfo, setEditInfo] = useState(false)

    useEffect(() => {
        if(user?.user.is_new_user==0){
         newModelInputFields.map(f => {
             if(f.name !=="email") f.isDisabled = false
         })
         setEditInfo(true)
         
        }
     }, [])

    useEffect(() => {
        setLoading(pre => ({ ...pre, info: true }))
        http.get(`/api/users/${user?.user?.id}`).then(res => {
            console.log("getLoggedInMember", res);

            if (res.data.success) {
                const mData =  res.data.data
                reset(mData)
                setModel(mData)
                setMember(mData)
                console.log("member ", mData);
              

                if (res.data) {
                    const img = mData?.image_data?.path
                    setPhoto({ url: img ? consts.BASE_URL + img : '', photo: null })
                }
            }
            setLoading(pre => ({ ...pre, info: false }))
        }, error => {
            setLoading(pre => ({ ...pre, info: false }))

            console.log('Error error');
        })
    }, [])



    const submit = async (data) => {
        console.log(data);
        setErrorMessage(null)

      //  delete data.email;
      data['no_pass_confirmation'] = true
      data['ref'] = 'profile';
        console.log('submit ', data);
        try {

            setLoading(pre => ({ ...pre, sumbit: true }))
            const res = await http.post('api/users', data);
            console.log('member ', res);
            if (res.data?.success) {
                const mUser ={... user};
                mUser.user =res.data.data
                setUser(mUser)
                toast.success(res.data.message);
            }


            setLoading(pre => ({ ...pre, sumbit: false }))

        } catch (error) {
            console.log("error", error);
            setLoading(pre => ({ ...pre, sumbit: false }))
            const err = error?.response?.data
            if (!err?.success) {
                setErrorMessage(err?.message)
                toast.error(err?.message);
            }
        }

    }
 

    const handleEnableInputFields = ()=>{
  
        setEditInfo(pre => {
            if(pre){
                newModelInputFields.map(f => {
                    if(f.name !=="email") f.isDisabled = true
                })
            }
            else{
                newModelInputFields.map(f => {
                    if(f.name !=="email") f.isDisabled = false
                })
            }
            return !pre
        })
        setErrorMessage(null)
    }



    return (
        <div className='relative'>
        <ABreadcrumbs links={breadcrumbs} />
           { member &&<div className='md:flex  items-start gap-4'>
                <Card className="w-full md:w-[70%]  p-2 md:p-4 mt-4 relative">
                    <div className='flex justify-between border-b pb-2'>
                        <p className="text-sm text-main-color font-bold ">{member?.full_name} پروفايل</p>
                        <Button onClick={handleEnableInputFields} color="amber" className='py-1 px-2 rounded-full drop-shadow-lg'> <AIcon name="create-outline" size={20} /> </Button>
                    </div>

                    <form className=" flex flex-col gap-4 mt-4" onSubmit={handleSubmit(submit)}>
                        

                            <div className='grid md:grid-cols-1 gap-4'>
                                {
                                    newModelInputFields?.map((data, i) => {
                                        return (
                                            <div key={i}>
                                                {
                                                    data?.type === 'text' || data.type === 'date' || data?.type === 'textarea' || data?.type === 'password' || data?.type === 'email' ?
                                                        <AInput v={{ register, errors, data }} />

                                                        : null
                                                }
                                            </div>
                                        )
                                    })
                                }
                               
                            </div>
                      
                        {errorMessage && <Typography
                            variant="small"
                            color="gray"
                            className="flex items-center text-red-500 gap-2 font-normal "
                        >
                            <AIcon name="alert-circle-outline" className="-mt-0.5 h-4 w-4" />
                            {errorMessage}
                        </Typography>}
                        <div className='flex gap-4 md:justify-end'>
                            <Button className="btn1 w-full md:w-[20%]" size='sm' type="submit" disabled={loading.submit  || !editInfo}>  {loading.submit ? <Spinner color="teal" className="h-4 w-4" /> : "ارسال"}    </Button>

                        </div>


                    </form>
                </Card>

                <div className='w-full  md:w-[30%] '>
                    <UploadPhoto v={{ obj: member?.image_data, className: "pt-4 relative", showSumitButton: true, member, title:'آپلود عکس پروفایل', modelName:'User'  }} />
                    <ResetPassword v={{member}} />
                    
                </div>

            </div>}
            {loading.info && <ASpinner />}
            <ToastContainer />
        </div>
    )
}
